import React, { Fragment, useState } from 'react';
import { Button, Dialog, DialogContent, DialogTitle, DialogActions } from '@material-ui/core';
import { Field, Formik } from 'formik';
import * as Yup from 'yup';

import { GQLPlatformSaleCatalog } from '@jewelutions/core-crm-server-api-client-domain';
import { ErrorComponent, JwlField, LoadingSpinner } from '../../../../components';
import { GQLOperationBuilder } from '../../../../operations/GQLOperationBuilder';

interface IProps {
  platformSaleCatalog: GQLPlatformSaleCatalog;
  onClose: (success: boolean) => void;
}

export const PlatformSaleCatalogEditDialog: React.FC<IProps> = ({ platformSaleCatalog, onClose }: IProps) => {
  const [errorComponentState, setErrorComponentState] = useState(false);
  const [platformSaleCatalogToPersist, setPlatformSaleCatalogToPersist] = useState(null as any);
  const initialValues = {
    name: platformSaleCatalog.name.en,
    description: platformSaleCatalog.description.en
  };

  const [
    editPlatformSaleCatalog,
    {
      error: errorEditNameAndDescriptionPlatformSaleCatalog,
      loading: editNameAndDescriptionPlatformSaleCatalogLoader
    }
  ] = GQLOperationBuilder.platformSaleCatalog.updateNameAndDescription();

  const onSubmit = (props: any) => {
    const mutationVariables = {
      name: { en: props.name },
      description: { en: props.description },
      platformSaleCatalogId: platformSaleCatalog.id
    };

    setPlatformSaleCatalogToPersist(props);
    editPlatformSaleCatalog({ variables: mutationVariables }).then(response => {
      onClose(true);
    });
  };

  if (errorEditNameAndDescriptionPlatformSaleCatalog && !errorComponentState)
    return (
      <Dialog open={true} maxWidth="md" aria-labelledby="edit-platform-sale-catalog">
        <ErrorComponent
          margins="0"
          close={setErrorComponentState}
          callback={() => onSubmit(platformSaleCatalogToPersist)}
          details={errorEditNameAndDescriptionPlatformSaleCatalog?.stack}
          message={errorEditNameAndDescriptionPlatformSaleCatalog?.message}
        />
      </Dialog>
    );

  if (editNameAndDescriptionPlatformSaleCatalogLoader) return <LoadingSpinner />;

  const validationSchema = Yup.object().shape({
    name: Yup.string().required('Name is required'),
    description: Yup.string().required('Description is required')
  });

  return (
    <Dialog open={true} aria-labelledby="edit-platform-sale-catalog">
      <Fragment>
        <DialogTitle>Edit name & description platform sale catalog</DialogTitle>
        <DialogContent>
          <Formik
            initialValues={{ ...initialValues }}
            validationSchema={validationSchema}
            onSubmit={onSubmit}
          >
            {({ values, touched, handleSubmit }) => (
              <form onSubmit={handleSubmit}>
                <Field name="name" component={JwlField} label="Name" />
                <Field name="description" component={JwlField} label="Description" />

                <DialogActions>
                  <Button color="primary" onClick={() => onClose(false)}>
                    Close
                  </Button>
                  <Button type="submit" color="primary" variant="contained">
                    Save
                  </Button>
                </DialogActions>
              </form>
            )}
          </Formik>
        </DialogContent>
      </Fragment>
    </Dialog>
  );
};

export default PlatformSaleCatalogEditDialog;
